module.exports = __webpack_public_path__ + "img/04_lip.680982ba.png";